import React, { useState } from 'react';
import styled from 'styled-components';
import menuApi from 'api/requests/menu';
import colors from 'theme/colors';

export default function CategoryForm({ slug, initialData, onSaved, onCancel }) {
    const [name, setName] = useState(initialData?.name || '');
    const [description, setDescription] = useState(initialData?.description || '');
    const [sortOrder, setSortOrder] = useState(initialData?.sort_order ?? '');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!name.trim()) { setError('Nome é obrigatório'); return; }
        setLoading(true);
        setError(null);
        try {
            const payload = {
                name: name.trim(),
                description: description.trim() || null,
                ...(sortOrder !== '' && { sort_order: Number(sortOrder) }),
            };
            const { data } = initialData
                ? await menuApi.updateCategory(slug, initialData.id, payload)
                : await menuApi.createCategory(slug, payload);
            onSaved(data);
        } catch (err) {
            setError('Erro ao salvar. Tente novamente.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <Form onSubmit={handleSubmit}>
            <Field>
                <Label>Nome *</Label>
                <Input
                    value={name}
                    onChange={e => setName(e.target.value)}
                    placeholder='Ex: Hambúrgueres'
                    autoFocus
                />
            </Field>

            <Field>
                <Label>Descrição</Label>
                <TextArea
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    placeholder='Opcional'
                    rows={3}
                />
            </Field>

            <Field style={{ maxWidth: 120 }}>
                <Label>Ordem de exibição</Label>
                <Input
                    type='number'
                    min='0'
                    value={sortOrder}
                    onChange={e => setSortOrder(e.target.value)}
                    placeholder='Ex: 1'
                />
            </Field>

            {error && <ErrorText>{error}</ErrorText>}

            <SubmitBtn type='submit' disabled={loading}>
                {loading ? 'Salvando...' : initialData ? 'Salvar alterações' : 'Criar categoria'}
            </SubmitBtn>
        </Form>
    );
}

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

const Label = styled.label`
    font-size: 13px;
    font-weight: 600;
    color: ${colors.nightDark};
`;

const Input = styled.input`
    border: 1.5px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 15px;
    outline: none;
    color: ${colors.nightDark};
    background: #fff;
    transition: border-color 0.15s;
    &:focus { border-color: ${colors.occasionalPurple}; }
    &::placeholder { color: #999; }
`;

const TextArea = styled.textarea`
    border: 1.5px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 15px;
    outline: none;
    color: ${colors.nightDark};
    background: #fff;
    resize: vertical;
    transition: border-color 0.15s;
    &:focus { border-color: ${colors.occasionalPurple}; }
    &::placeholder { color: #999; }
`;

const ErrorText = styled.p`
    color: ${colors.danger};
    font-size: 13px;
    margin: 0;
`;

const SubmitBtn = styled.button`
    padding: 14px;
    border-radius: 10px;
    background: ${({ disabled }) => disabled ? colors.neutralDark : colors.occasionalPurple};
    color: ${({ disabled }) => disabled ? colors.nightLight : '#fff'};
    font-size: 15px;
    font-weight: 700;
    border: none;
    cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    transition: opacity 0.15s;
    &:hover:not(:disabled) { opacity: 0.9; }
`;
